import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonUIService } from 'src/app/sections/common/services/common.ui.service';

@Component({
  selector: 'app-note-popup',
  templateUrl: './note-popup.component.html',
  styleUrls: ['./note-popup.component.scss']
})
export class NotePopupComponent {

  @Input() note: string = '';
  @Input() id: string = '';

  constructor(public commonUiService: CommonUIService, private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  onClose(event: any) {
    event.stopPropagation();
    this.commonUiService.previewNoteId = "";    
  }

}
